import { css } from '@linaria/core';
import { Typography } from 'antd';

interface Props {
  imageUrl: string | null;
  nameEn: string;
  namePt?: string;
}

const styles = {
  container: css`
    display: flex;
    align-items: center;
    gap: var(--ant-margin-sm);
    min-width: 0;
  `,
  names: css`
    display: flex;
    flex-direction: column;
    min-width: 0;
  `,
  thumbnail: css`
    width: 32px;
    height: 44px;
    flex: none;
    object-fit: contain;
    border-radius: var(--ant-border-radius-sm);
    background: var(--ant-color-fill-secondary);
  `,
};

const CardSearchOption = ({ imageUrl, nameEn, namePt }: Props) => (
  <span className={styles.container}>
    {imageUrl ? (
      <img
        alt=""
        aria-hidden="true"
        className={styles.thumbnail}
        src={imageUrl}
      />
    ) : null}
    <span className={styles.names}>
      <Typography.Text ellipsis>{namePt || nameEn}</Typography.Text>
      {namePt && namePt !== nameEn ? (
        <Typography.Text type="secondary" ellipsis>
          {nameEn}
        </Typography.Text>
      ) : null}
    </span>
  </span>
);

export default CardSearchOption;
